import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import Header from './components/Header';
import Footer from './components/Footer';
import Contact from './components/Contact';
import { ThemeProvider } from './components/ThemeContext';
import './App.css';
import NotFound from './components/NotFound';
import About from './components/About';

const App = () => {
  // Parallax effect for spheres
  // useEffect(() => {
  //   const handleScroll = () => {
  //     const shapes = document.querySelectorAll('.shape');
  //     const scrollPosition = window.scrollY;
      
  //     shapes.forEach((shape, index) => {
  //       const speed = (index + 1) * 0.5; // Customize the speed for each shape
  //       shape.style.transform = `translateY(${scrollPosition * speed}px)`;
  //     });
  //   };

  //   window.addEventListener('scroll', handleScroll);
    
  //   return () => window.removeEventListener('scroll', handleScroll);
  // }, []);

  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/*" element={<NotFound />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
};

export default App;
